var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampfireActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#fff",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 13.4318c0 1.4768-.5268 2.8931-1.4645 3.9373-.9376 1.0443-2.2094 1.6309-3.5355 1.6309s-2.59784-.5866-3.53552-1.6309c-.93768-1.0442-1.46446-2.4605-1.46446-3.9373-.00275-1.2153.35583-2.3974 1.01976-3.3619.27717-.4342.61368-.81739.9973-1.13564.07565-.05921.16586-.09098.25831-.09098.09246 0 .18267.03177.25831.09098.07667.06237.13363.1502.16268.25087.02906.10067.02872.209-.00095.30944-.15335.65613-.15335 1.34503 0 2.00113.07138.2584.21773.483.41607.6387.1984.1558.4376.2338.6801.2218.101.0017.2012-.0212.2935-.067s.1746-.1134.2411-.1981c.0615-.1482.0934-.3095.0934-.4728s-.0319-.3246-.0934-.4728c-1.34775-5.13792.3279-6.00341.5256-6.11347.0702-.02943.146-.03878.2203-.02721s.1449.0437.2052.09346c.0603.04975.1085.11555.1401.19137.0316.07581.0456.15924.0408.24266-.0718.8655-.1303 1.55089 1.1905 2.46641l.0764.04503c2.7089 1.59591 3.2749 3.81215 3.2749 5.38805z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfireActive);
export default __webpack_public_path__ + "static/media/campfire_active.5364e5de6f415eda00bbbf5d78866df0.svg";
export { ForwardRef as ReactComponent };